import { ChangeDetectionStrategy, Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor, FormBuilder, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { Interval } from '@core/models/interval.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'gt-enhanced-interval',
  templateUrl: './enhanced-interval.component.html',
  styles: [
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => EnhancedIntervalComponent),
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EnhancedIntervalComponent implements ControlValueAccessor, OnInit, OnDestroy {

  @Input() label = '';

  form = this.fb.group({
    years: [0, Validators.required],
    months: [0, Validators.required],
    days: [0, Validators.required],
    hours: [0, Validators.required],
    minutes: [0, Validators.required],
    seconds: [0, Validators.required],
  });

  get value(): Interval {
    return this.form.value;
  }

  set value(value: Interval) {
    this.form.setValue(value);
    this.onChange(value);
    this.onTouched();
  }
  private subs = new Subscription();

  disabled = false;

  constructor(
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.subs.add(
      this.form.valueChanges.subscribe(value => {
        this.onChange(value);
        this.onTouched();
      })
    );
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  writeValue(val: any) {
    this.value = val;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onChange(value: Interval) { }
  onTouched() { }
}
